"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.search");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.search");

require("url-search-params-polyfill");

var _utils = require("../helpers/utils");

var _quickView = _interopRequireDefault(require("../components/quick-view"));

var _infiniteScrollMemory = _interopRequireDefault(require("../components/infinite-scroll-memory"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}
/**
 * DOM selectors.
 */


var selectors = {
  sortSelector: '[js-collection="sortBy"]'
};
/**
 * Create a new sort by filter.
 */

var sortByFilter = function sortByFilter() {
  /**
   * Node selectors.
   */
  var selectMenu = document.querySelector(selectors.sortSelector);
  var searchParams = new URLSearchParams(window.location.search);
  /**
   * Initialise sort by component.
   */

  function exposeQuickView() {
    theme.quickview = function () {
      (0, _quickView["default"])().init();
    };
  }
  /**
   * Initialise sort by infinite scroll memory
   */


  function exposeInfiniteScrollMemory() {
    (0, _infiniteScrollMemory["default"])().init();
  }

  function init() {
    exposeQuickView();
    setSelectEvents();
    exposeInfiniteScrollMemory();

    if (window.location.search) {
      updateSortBy();
    }
  }
  /**
   * Set sort by select events.
   */


  function setSelectEvents() {
    if (_typeof(selectMenu) !== 'object') {
      (0, _utils.on)('change', selectMenu, function (event) {
        return handleChangeEvent(event);
      });
    }
  }
  /**
   * Handle event from select menu.
   * @param {Event} event - Change event.
   */


  function handleChangeEvent(event) {
    event.preventDefault();
    var newSearchParams = new URLSearchParams();
    newSearchParams.set(event.currentTarget.name, event.currentTarget.value);
    window.location = "".concat(window.location.origin).concat(window.location.pathname, "?sort_by").concat(newSearchParams);
  }
  /**
   * Update default state of selector by using selectedIndex.
   */


  function updateSortBy() {
    if (_typeof(selectMenu) !== 'object') {
      selectMenu.options.selectedIndex = getSelectedOption().index;
    }
  }
  /**
   * Get selected option from search parameters in URL string.
   */


  function getSelectedOption() {
    return _toConsumableArray(selectMenu.options).filter(function (element) {
      return element.value.match(searchParams.get('sort_by'));
    })[0];
  }
  /**
   * Expose public interface.
   */


  return Object.freeze({
    init: init
  });
};
/**
 * Instantiate collection modules.
 */


document.addEventListener('DOMContentLoaded', function () {
  sortByFilter().init();

  if (theme.features.quickview) {
    (0, _quickView["default"])().init();
  }
});